<template>
    <div class="card serp-card">
        <div class="card-header flex-column align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="g-wordmark mr-2" aria-hidden="true">
                    <span class="g g--b">G</span><span class="g g--r">o</span><span class="g g--y">o</span>
                    <span class="g g--b">g</span><span class="g g--g">l</span><span class="g g--r">e</span>
                    <span class="ml-2 f-12">SERP Snippet Preview</span>
                </div>
                <e-btn-language class="ml-auto" variant="light" @input="currentLang = $event" :value="currentLang" show-label/>
            </div>

            <div class="mt-2 d-none d-md-flex align-items-center text-muted small serp-metrics">
                <span class="mr-3">Title: <strong>{{ titlePx }}</strong> / {{ MAX_TITLE_PX }}px</span>
                <span class="mr-3">URL: <strong>{{ urlPx }}</strong> / {{ MAX_URL_PX }}px</span>
                <span>Description: <strong>{{ descPx }}</strong> / {{ MAX_DESC_PX }}px</span>
            </div>
        </div>

        <div class="px-3 pt-3 pb-2 d-flex flex-wrap align-items-center">
            <div class="custom-control custom-switch mr-4">
                <input type="checkbox" class="custom-control-input" id="serpRich" v-model="showRich">
                <label class="custom-control-label" for="serpRich">Rich Snippet</label>
            </div>
            <div class="custom-control custom-switch mr-4">
                <input type="checkbox" class="custom-control-input" id="serpDate" v-model="showDate">
                <label class="custom-control-label" for="serpDate">Date</label>
            </div>

<!--            <div class="ml-auto btn-group btn-group-sm" role="group" aria-label="Language">-->
<!--                <button type="button" class="btn" :class="currentLang==='fr' ? 'btn-primary' : 'btn-outline-secondary'"-->
<!--                        @click="currentLang='fr'">-->
<!--                    <i class="fas fa-desktop mr-1"></i> Fr-->
<!--                </button>-->
<!--                <button type="button" class="btn" :class="currentLang==='en' ? 'btn-primary' : 'btn-outline-secondary'"-->
<!--                        @click="currentLang='en'">-->
<!--                    <i class="fas fa-mobile-alt mr-1"></i> En-->
<!--                </button>-->
<!--            </div>-->
        </div>

        <!-- Google bar -->
        <div class="px-3 py-3 border-top">
            <div class="d-flex align-items-center">
                <div class="g-wordmark g-wordmark--sm mr-3" aria-hidden="true">
                    <span class="g g--b">G</span><span class="g g--r">o</span><span class="g g--y">o</span>
                    <span class="g g--b">g</span><span class="g g--g">l</span><span class="g g--r">e</span>
                </div>
                <div class="flex-grow-1 position-relative">
                    <input class="form-control serp-search" type="text" :value="queryText" readonly>
                    <div class="serp-search-icons">
                        <i class="fas fa-search"></i>
                        <i class="fas fa-microphone-alt ml-2"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabs -->
        <div class="px-3 d-flex align-items-center serp-tabs">
            <button class="serp-tab active">
                <i class="fa-sharp fa-light fa-magnifying-glass mr-2"></i>All
            </button>
            <button class="serp-tab">
                <i class="fa-sharp fa-light fa-image mr-2"></i>image
            </button>
            <button class="serp-tab">
                <i class="fa-sharp fa-light fa-camera mr-2"></i>Videos
            </button>
            <button class="serp-tab">
                <i class="fa-sharp fa-light fa-newspaper mr-2"></i>News
            </button>
            <button class="serp-tab">
                <i class="fa-sharp fa-light fa-location-dot mr-2"></i>Map
            </button>
            <button class="serp-tab">
                <i class="fa-light fa-ellipsis-vertical mr-2"></i>More
            </button>
        </div>

        <!-- Result -->
        <div class="p-3 pt-2">
            <div :class="['serp-results', device]">
                <div class="serp-result">
                    <div class="serp-host">{{ previewHost }}</div>
                    <div class="serp-title">{{ truncatedTitle }}</div>

                    <div v-if="showRich" class="serp-stars">
                        <div class="stars">
                            <i v-for="n in 5" :key="n" class="fa-sharp fa-solid fa-star fa-xs" style="color: #FFD43B"/>
                        </div>
                        <span class="rating">Rating: 9,4/10 - 112 votes</span>
                    </div>

                    <div class="serp-desc">
                        <span v-if="showDate" class="date">8 Apr, 2021 – </span>
                        <span>{{ truncatedDescription }}</span>
                    </div>
                </div>
            </div>

            <!-- Mobile metrics line -->
            <div class="d-md-none mt-3 text-muted small text-right">
                Title: <strong>{{ titlePx }}</strong> / {{ MAX_TITLE_PX }}px ·
                URL: <strong>{{ urlPx }}</strong> / {{ MAX_URL_PX }}px ·
                Description: <strong>{{ descPx }}</strong> / {{ MAX_DESC_PX }}px
            </div>
        </div>
    </div>
</template>

<script>
import EBtnLanguage from "./e-btn-language.vue";

export default {
    name: `serp-snippet-simulator`,
    components: {EBtnLanguage},
    props: {
        title: {type: Object},
        description: {type: Object},
        permalink: {type: Object},
        baseUrl: {type: String, default: `eye-in.com`},
    },
    data() {
        return {
            device: `desktop`,
            currentLang: `en`,
            showRich: true,
            showDate: true,
            MAX_TITLE_PX: 580,
            MAX_URL_PX: 385,
            MAX_DESC_PX: 990,
            titlePx: 0,
            urlPx: 0,
            descPx: 0
        };
    },
    computed: {
        url() {
            return `https://${this.baseUrl}/${this.permalink[this.currentLang]}`
        },
        fonts() {
            return {
                title: `500 20px Arial, Helvetica, sans-serif`,
                url: `normal 14px Arial, Helvetica, sans-serif`,
                desc: `normal 14px Arial, Helvetica, sans-serif`
            };
        },
        safeTitle() {
            return (this.computedTitle || ``).trim() || `Example Title Goes Here`;
        },
        safeDescription() {
            return (this.computedDescription || ``).trim() ||
                `This is a sample meta description preview. It will be truncated based on pixel width to mimic Google’s SERP.`;
        },
        previewHost() {
            try {
                const u = new URL(this.url);
                return (u.host + (u.pathname === `/` ? `` : u.pathname)).replace(/\/+$/, ``);
            } catch (e) {
                return this.url || `example.com`;
            }
        },
        truncatedTitle() {
            return this.truncateToPx(this.safeTitle, this.fonts.title, this.MAX_TITLE_PX);
        },
        truncatedDescription() {
            return this.truncateToPx(this.safeDescription, this.fonts.desc, this.MAX_DESC_PX);
        },
        queryText() {
            return (this.safeTitle || `example query`).slice(0, 48);
        },
        computedTitle() {
            return this.title[this.currentLang];
        },
        computedDescription() {
            return this.description[this.currentLang];
        }
    },
    watch: {
        computedTitle() {
            this.$nextTick(this.updateMetrics);
        },
        url() {
            this.$nextTick(this.updateMetrics);
        },
        computedDescription() {
            this.$nextTick(this.updateMetrics);
        },
        device() {
            this.$nextTick(this.updateMetrics);
        }
    },
    mounted() {
        this.updateMetrics();
    },
    methods: {
        updateMetrics() {
            this.titlePx = this.measure(this.safeTitle, this.fonts.title);
            this.urlPx = this.measure(this.previewHost, this.fonts.url);
            this.descPx = this.measure(this.safeDescription, this.fonts.desc);
        },
        measure(text, font) {
            if (!this._canvas) this._canvas = document.createElement(`canvas`);
            const ctx = this._canvas.getContext(`2d`);
            ctx.font = font;
            return Math.round(ctx.measureText(text).width);
        },
        truncateToPx(text, font, maxPx) {
            if (this.measure(text, font) <= maxPx) return text;
            let lo = 0, hi = text.length, fit = 0, ell = `…`;
            while (lo <= hi) {
                const mid = (lo + hi) >> 1;
                const chunk = text.slice(0, mid) + ell;
                const w = this.measure(chunk, font);
                if (w <= maxPx) {
                    fit = mid;
                    lo = mid + 1;
                } else {
                    hi = mid - 1;
                }
            }
            return text.slice(0, fit) + ell;
        }
    }
};
</script>

<style scoped>
/* Base */
.serp-card {
    border: 1px solid #ebebeb;
    box-shadow: 0 1px 2px rgba(60, 64, 67, .15);
}

.g-wordmark {
    font-size: 28px;
    font-weight: 600;
    letter-spacing: .2px;
    user-select: none;
}

.g-wordmark--sm {
    font-size: 22px;
}

.g {
    display: inline-block;
}

.g--b {
    color: #4285f4
}

.g--r {
    color: #ea4335
}

.g--y {
    color: #fbbc05
}

.g--g {
    color: #34a853
}

.serp-metrics span strong {
    font-weight: 600;
}

/* Search */
.serp-search {
    border-radius: 24px;
    padding-right: 72px;
}

.serp-search-icons {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    color: #5f6368;
}

.serp-search-icons i {
    font-size: 14px;
}

/* Tabs */
.serp-tabs {
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
}

.serp-tab {
    background: transparent;
    border: 0;
    padding: 10px 0;
    margin-right: 18px;
    color: #5f6368;
    font-size: 14px;
}

.serp-tab.active {
    color: #1a73e8;
    border-bottom: 3px solid #1a73e8;
    font-weight: 600;
}

.serp-tab .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #5f6368;
    margin-right: 6px;
}

/* Results */
.serp-results.desktop {
    max-width: 920px;
}

.serp-results.mobile {
    max-width: 360px;
}

.serp-result {
    padding-top: 12px;
}

.serp-host {
    font-size: 12px;
    color: #5f6368;
    margin-bottom: 6px;
}

.serp-title {
    font-size: 20px;
    line-height: 1.3;
    font-weight: 500;
    color: #1a0dab;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

.serp-title:hover {
    text-decoration: underline;
}

.serp-stars {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 6px 0;
}

.serp-stars .stars {
    display: flex;
    gap: 2px;
}

.serp-stars svg {
    width: 16px;
    height: 16px;
    fill: #fbbc05;
}

.serp-stars .rating {
    font-size: 13px;
    color: #5f6368;
}

.serp-desc {
    font-size: 14px;
    color: #4d5156;
}

.serp-desc .date {
    color: #5f6368;
}
</style>
